import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(
  (theme) => ({
    title: {
      ...theme.eatclub.typography.cancelTitle,
      maxWidth: '800px',
    },
    mainContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: '60px',
      lineHeight: '1.4',
    },
    pageContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: '60px',
      fontSize: '18px',
      // maxWidth: '800px',
    },
    dateContent: {
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'flex-start',
      justifyContent: 'flex-start',
      // gap: '12px',
    },
    dateNumber: {
      paddingTop: '10px',
      fontSize: '26px',
    },
    dateMonth: {
      paddingTop: '4px',
      fontSize: '14px',
    },
  }),
  { name: 'SchedulePage' },
);

export default useStyles;

export const toggleGroupStyles = {
  label: {
    paddingBottom: '24px',
    margin: 0,
  },
  groupContainer: {
    gap: '12px',
  },
  option: {
    flexGrow: 1,
    alignItems: 'flex-start',
    justifyContent: 'center',
    border: '1px solid #E1D7C8',
    borderRadius: '8px',
    backgroundColor: 'transparent',
    padding: '15px 8px',
    fontSize: '15px',
  },
  groupOptionContainer: {
    width: '104px',
    // height: '106px',
  },
  hoveredOption: {
    border: '1px solid #313131',
  },
  selectedOption: {
    border: '1px solid black',
    outline: '1px solid black',
  },
};
